/**
 * Harita altlığı tanımı (P6).
 *
 * Varsayılan: OpenStreetMap standart karoları (`https://tile.openstreetmap.org/{z}/{x}/{y}.png`),
 * ücretsiz ve anahtar gerektirmez. Atıf zorunlu (ODbL lisansı); metin i18n'den gelir ve harita
 * ekranları ayrıca atıf eklemez (tek kaynak: `tiles.attribution.*`).
 *
 * `VITE_MAPTILER_KEY` ortam değişkeni tanımlıysa MapTiler kullanılır (mevcut davranış).
 * Anahtar yoksa "harita yok" uyarısı artık gösterilmez — OSM altlığı her zaman açık.
 */

import { t } from '@aquabox/shared';

export interface TileConfig {
  url: string;
  attribution: string;
  maxZoom: number;
}

/** MapTiler anahtarı varsa MapTiler, yoksa OSM döner. */
export function resolveTileConfig(maptilerKey: string | null | undefined): TileConfig {
  if (maptilerKey && maptilerKey.trim()) {
    return {
      url: `https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=${maptilerKey}`,
      attribution: t('tiles.attribution.maptiler'),
      maxZoom: 19,
    };
  }
  return {
    url: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: t('tiles.attribution.osm'),
    maxZoom: 19,
  };
}

/** Panel tarafında `import.meta.env` üzerinden okunur; testlerde parametre geçirilebilir. */
export function getTileConfig(): TileConfig {
  return resolveTileConfig((import.meta.env.VITE_MAPTILER_KEY as string | undefined) ?? '');
}
